import isMobile from 'is-mobile';
import $Scriptjs from 'scriptjs';
import moment from 'moment';
import { loggedIn, getUser } from '@/plugins/auth';

const googleApi =
	'https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing,places,geocoding&key=AIzaSyBq4QEKaiRmSx9RvgG-k9LOoFQtTaRXIng';

const mixins = {
	computed: {
		globalBackground() {
			return this.$vuetify.theme.isDark ? 'bgDark' : 'bgLight';
		},
		isMobile() {
			return isMobile();
		},
		loggedIn() {
			return loggedIn();
		},
		userProfile() {
			return getUser();
		},
	},
	mounted() {
		$Scriptjs(googleApi);
		moment.locale('es');
	},
};

export default mixins;
